export default __webpack_public_path__ + "static/media/error.9dd64da8.svg";